export const environment = {
  apiUrl: 'https://api-dev-1of1events.onrender.com',
  supabaseUrl: 'https://gtdidcycyrirvrafutat.supabase.co',
  supabaseKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd0ZGlkY3ljeXJpcnZyYWZ1dGF0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM2ODIyMzUsImV4cCI6MjA4OTI1ODIzNX0.IYEBqEhKMiku7yjyRFPqQFj-Z3Zm-awQX04PUGv57_w',
};
